import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import Pyth from '../abis/Pyth';
import { getContractAddress } from '../constants';

export const getPythContract = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('Pyth', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: Pyth,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
